<template>
  <article-layout>
        <div class="subpage-top">
            <h1>Foto's</h1>
            <router-link to="/#gallery">Terug</router-link>
        </div>
        <div class="columns is-multiline">
          <div class="column is-two-fifth-mobile is-half-tablet is-one-third-desktop is-one-quarter-widescreen" v-for="(image, index) in source" :key="index">
            <figure class="image is-1by1">
                <img class="picture" :src="image" @click="bigImageIndex = index" alt="Belgische Mastiff Belgische Trekhond">
            </figure>
          </div>
        </div>
        <template>
          <div>
            <vue-gallery :images="source" :index="bigImageIndex" @close="bigImageIndex = null"></vue-gallery>
          </div>
        </template>
    </article-layout>
</template>

<script>
import ArticleLayout from "./ArticleLayout";
import VueGallery from "vue-gallery";
import axios from 'axios';

export default {
    name: "PicturesDetailed",
    data: function() {
      return {
        source: [],
        bigImageIndex: null
      }
    },
    components: {
        ArticleLayout, VueGallery
    },
    mounted: function() {
      axios.get(process.env.VUE_APP_IMAGES_URL + '/collection/index.json').then(indexJson => {
        indexJson.data.forEach(imageJson => {
          this.source.push(process.env.VUE_APP_IMAGES_URL + imageJson.location);            
        });
      });
      axios.get(process.env.VUE_APP_IMAGES_URL + '/pup/index.json').then(indexJson => {
        indexJson.data.forEach(imageJson => {
          this.source.push(process.env.VUE_APP_IMAGES_URL + imageJson.location);            
        });
      });
      axios.get(process.env.VUE_APP_IMAGES_URL + '/carousel/index.json').then(indexJson => {
        indexJson.data.forEach(imageJson => {
          this.source.push(process.env.VUE_APP_IMAGES_URL + imageJson.location);            
        });
      });
    }
}
</script>

<style scoped>
    .picture {
      object-fit: cover;
    }
    .picture:hover {
        cursor: pointer;
    }
</style>